import { /* setUrls, */ urls } from '../utilities/dataHelpers';
import * as log from '../utilities/log';
import mediator from '../utilities/mediator';
import { /* observeStore, */ store } from '../utilities/store';

import { update as updateConfig } from '../reducers/config/reducer';
import { ConfigState } from '../models';

const _getConfigWithCountry = (country: string) => {
  return new Promise<ConfigState>((resolve, reject) => {
    mediator
      .request<ConfigState>('api:invoke', {
        method: 'POST',
        url: urls.api + 'config',
        data: {
          country,
        },
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleUpdateConfig = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    _getConfigWithCountry(request.country)
      .then((res) => {
        if (store) {
          store.dispatch(updateConfig(res));
        }

        // this allows a service to wait until an update is done
        mediator.publish('config:updatedConfigForCountry', {
          country: request.country,
        });
        resolve(res);
      })
      .catch((err) => {
        // what do we do here?
        log.error(err);
        reject(err);
      });
  });
};

mediator.once('store:created', () => {
  // Update the service urls when config changes
  // observeStore((state) => state.config, setUrls);
});

mediator.subscribe('config:updateConfig', handleUpdateConfig);
